// Modules
import React from 'react'
import { Redirect, useHistory } from 'react-router-dom'
import { FormikHelpers } from 'formik'

// Application
import { useActiveCIPOrphanHook, useAnalytics } from 'hooks'
import { Analytics, OutputErrorCode, OutputErrorMsg, ROUTES_PATH } from 'constants/index'
import { convertToNumber } from 'utils'

// Components
import { Header, TemplateContainer } from 'components'
import { Cellphone, CellphoneInitial } from 'components/Presenters/Cellphone'
import { ErrorResponse } from 'apollo-link-error'

export const NEWCIPPhone: React.FC = () => {
    const history = useHistory()
    const {
        name,
        birthDate,
        cpf,
        hasMounted,
        biologicalSex,
        password,
        setPhone,
        createPatientAccount,
        setSubmitting,
        isSubmitting,
        setAccount,
    } = useActiveCIPOrphanHook()

    const shouldRedirect = !cpf || !biologicalSex || !password

    useAnalytics(Analytics.ActivateAccountCipOrphan.NewAccountPhone, !shouldRedirect)

    if (!hasMounted) {
        return null
    }

    if (shouldRedirect) {
        return <Redirect to={ROUTES_PATH.SIGN_UP_REGISTER_ACTIVATION_CPF} />
    }

    const handleSubmit = async (values: CellphoneInitial, bag: FormikHelpers<CellphoneInitial>) => {
        const { setFieldError } = bag

        try {
            const { cellphone } = values

            await setSubmitting(true)
            await setPhone(cellphone)

            const {
                createPatientAccount: { patient, cipIntegrationStatus },
            } = await createPatientAccount({
                name,
                birthDate,
                cellphone: convertToNumber(cellphone),
                cpf,
                password,
                biologicalSex,
            })

            setAccount({ id: patient.id, patientLoginMdmAccount: cipIntegrationStatus })

            await setSubmitting(false)
            history.push(ROUTES_PATH.SIGN_UP_NEW_CIP_VALIDATE_TOKEN)
        } catch (err) {
            await setSubmitting(false)
            const e: ErrorResponse = err

            if (e.graphQLErrors) {
                const error = e.graphQLErrors[0].extensions?.code
                if (error === OutputErrorCode.PHONEALREADYINUSE) {
                    setFieldError('cellphone', 'Telefone já cadastrado na plataforma')
                } else {
                    setFieldError('cellphone', OutputErrorMsg.GENERICERROR)
                }
                return
            }
        }
    }

    return (
        <TemplateContainer>
            <Header subtitle="Para utilizar nossos serviços precisamos validar seu celular." title="Qual é seu celular?" />
            <Cellphone handleSubmit={handleSubmit} initialValues={{ cellphone: '' }} isSubmiting={isSubmitting} />
        </TemplateContainer>
    )
}
